import Container from "../components/Container";

const NotFound = () => {
  return (
    <>
      <Container>
        <div className="signup__bg">
          <h1 className="heading-primary">404</h1>
          <p>You can't cook here</p>
        </div>
      </Container>
    </>
  );
};

export default NotFound;
